import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createBlock as _createBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderSlot as _renderSlot, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-123b8e14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-field" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id", "name", "min"]
const _hoisted_4 = { key: 8 }
const _hoisted_5 = { class: "error" }

import { computed, ref } from 'vue';
  import ChipsInput from '@/components/ChipsInput.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'InputField',
  props: {
    type: null,
    label: null,
    selected: null,
    options: null,
    optionLabel: null,
    placeholder: null,
    id: null
  },
  emits: ["update:selected"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update:selected', newValue: any): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    type: string //'dropdown' | 'date' | 'text' | 'chips' | 'zip' | 'selectbutton' | 'textarea';
    label?: string;
    selected?: any | any[];
    options?: any[];
    optionLabel?: string;
    placeholder?: string;
    id?: string;
  };

  

  

  const today = new Date();
  const tomorrow = ref<Date>(new Date(today.setDate(today.getDate() + 1)));

  const selected = computed({
    get: () => {
      return props.selected;
    },
    set: (newValue) => {
      emit('update:selected', newValue);
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: props.id
        }, _toDisplayString(props.label) + ":", 9, _hoisted_2))
      : _createCommentVNode("", true),
    (props.type === 'dropdown')
      ? (_openBlock(), _createBlock(_component_Dropdown, {
          key: 1,
          class: "dropdown",
          appendTo: "self",
          id: props.id,
          modelValue: _unref(selected),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null)),
          options: props.options,
          optionLabel: props.optionLabel,
          placeholder: props.placeholder||'',
          scrollHeight: "400px"
        }, null, 8, ["id", "modelValue", "options", "optionLabel", "placeholder"]))
      : (props.type === 'date' && props.options)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 2,
            id: props.id,
            class: _normalizeClass(props.selected === undefined || props.selected === '' ? 'placeholder' : ''),
            type: "date",
            name: props.label,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null)),
            min: tomorrow.value.toISOString().split('T')[0]
          }, null, 10, _hoisted_3)), [
            [_vModelText, _unref(selected)]
          ])
        : (props.type === 'chips')
          ? (_openBlock(), _createBlock(ChipsInput, {
              key: 3,
              selected: _unref(selected),
              "onUpdate:selected": _cache[2] || (_cache[2] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null)),
              id: props.id,
              options: props.options!,
              optionLabel: props.optionLabel || '',
              placeholder: "weitere..."
            }, null, 8, ["selected", "id", "options", "optionLabel"]))
          : (props.type === 'text')
            ? (_openBlock(), _createBlock(_component_InputText, {
                key: 4,
                id: props.id,
                type: "text",
                modelValue: _unref(selected),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null)),
                placeholder: props?.placeholder
              }, null, 8, ["id", "modelValue", "placeholder"]))
            : (props.type === 'zip')
              ? (_openBlock(), _createBlock(_component_InputMask, {
                  key: 5,
                  id: props.id,
                  modelValue: _unref(selected),
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null)),
                  mask: "99999",
                  placeholder: props.placeholder
                }, null, 8, ["id", "modelValue", "placeholder"]))
              : (props.type === 'selectbutton')
                ? (_openBlock(), _createBlock(_component_SelectButton, {
                    key: 6,
                    modelValue: _unref(selected),
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null)),
                    options: props.options,
                    optionLabel: props.optionLabel,
                    unselectable: false
                  }, null, 8, ["modelValue", "options", "optionLabel"]))
                : (props.type === 'textarea')
                  ? (_openBlock(), _createBlock(_component_Textarea, {
                      key: 7,
                      class: "textarea",
                      modelValue: _unref(selected),
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null)),
                      autoResize: true,
                      rows: "5",
                      placeholder: props?.placeholder
                    }, null, 8, ["modelValue", "placeholder"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4)),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "errorMessage")
    ])
  ]))
}
}

})